var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"jump-btn",class:{
    'up': _vm.scrollDirection === -1,
    'down': _vm.scrollDirection === 1,
    hidden: _vm.hidden,
    isAtTop: _vm.isAtTop,
    isAtBottom: _vm.isAtBottom,
  },attrs:{"variant":"primary"},on:{"click":_vm.clickHandler}},[_c('i',{staticClass:"fas fa-angle-double-down"})])
}
var staticRenderFns = []

export { render, staticRenderFns }